import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Purchases, type Package, ErrorCode } from "@revenuecat/purchases-js";
import { useTranslation } from "react-i18next";

import { QUERY_KEYS } from "../constants";
import Logger from "../../utils/logger";
import { showErrorToastDanger, showSuccessToast } from "../../utils/show-toast";

function usePurchaseSubscriptionMutation() {
  const queryClient = useQueryClient();
  const { t } = useTranslation("toasts");

  const mutation = useMutation({
    mutationFn: async (pkg: Package) => {
      const purchases = Purchases.getSharedInstance();
      return purchases
        .purchase({
          rcPackage: pkg,
        })
        .catch((error) => {
          Logger.log("[RevenueCat] User cancelled purchase");
          showErrorToastDanger(t("unable_to_complete"));
        });
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.SUBSCRIPTION.IS_SUBSCRIBED],
      });
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.SUBSCRIPTION.OFFERINGS],
      });
      data && showSuccessToast(t("subscription_successful"));
    },
    onError: (error: any) => {
      if (error?.errorCode === ErrorCode.UserCancelledError) {
        Logger.log("[RevenueCat] User cancelled purchase");
        return;
      }
      showErrorToastDanger(t("unable_to_complete"));
    },
  });

  return mutation;
}

export default usePurchaseSubscriptionMutation;
